var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"caption font-weight-bold",class:_vm.colorcss,staticStyle:{"height":"100%"},attrs:{"justify":"center","align":"center"}},[(_vm.hasSetCost)?_c('span',[_vm._v(_vm._s(_vm.formatedDiff))]):_c('span',[_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }